import { skillCategory as schema } from 'store/common/schemas';
import { createEntitiesReducer, noOpReducer, createEntitiesSelector } from './helpers';

import { skillCategories } from 'resources/skills/categories';

export const reducer = createEntitiesReducer(schema, noOpReducer, skillCategories);

export const selector = createEntitiesSelector(schema);
